
<div id="profile_view-wrap" class="profile_wrap">
    <div id="profile-cover-image" class="profile-cover-image">
        <img [src]="profileUser?.cover|getImgPath:'images'">
    </div>
    <div class="row">
        <div class="user-details">
            <div class="details-row">
                <div class="details-block">
                    <div class="avatar-container">
                        <label>
                            <img class="avatar" style="cursor: unset" id="profile-image"
                                 [src]="profileUser?.avatar|getImgPath: 'images'">
                        </label>
                    </div>

                    <div>
                        <strong id="user-full-name">{{profileUser?.first_name + ' ' + profileUser?.last_name}}</strong>
<!--                        <p class="connections-count">{{connectionsCount + ' connection' + (connectionsCount === 1 ? '' : 's')}} </p>-->
                    </div>
                </div>

<!--                <div id="profile-actions-block">-->


<!--                    <ng-container *ngIf="!ownProfile">-->

<!--                        <a class="add-friend-btn" (click)="connectWithUser()"-->
<!--                           *ngIf="usersConnectionStatus==='idle'">-->
<!--                            <mat-icon>person_add</mat-icon>-->
<!--                            <span>Connect</span>-->
<!--                        </a>-->

<!--                        <a class="waiting-for-confirmation-btn"-->
<!--                           *ngIf="usersConnectionStatus==='pending'" [matMenuTriggerFor]="pendingMenu">-->
<!--                            <mat-icon>check</mat-icon>-->
<!--                            <span>Waiting for confirmation</span>-->
<!--                        </a>-->

<!--                        <mat-menu #pendingMenu="matMenu">-->
<!--                            <button mat-menu-item (click)="cancelUsersConnecting(usersConnection)">-->
<!--                                <mat-icon>close</mat-icon>-->
<!--                                <span>Cancel</span>-->
<!--                            </button>-->
<!--                        </mat-menu>-->

<!--                        <button class="users-connected-btn" *ngIf="usersConnectionStatus==='connected' "-->
<!--                                [matMenuTriggerFor]="menu">-->
<!--                            <mat-icon>check</mat-icon>-->
<!--                            <span>Connected</span>-->
<!--                        </button>-->

<!--                        <mat-menu #menu="matMenu">-->
<!--                            <button mat-menu-item (click)="disconnectUser()">-->
<!--                                <mat-icon>close</mat-icon>-->
<!--                                <span>Disconnect</span>-->
<!--                            </button>-->
<!--                        </mat-menu>-->

<!--                        <a (click)="toggleBottomChatBox()" class="toggle-chat-box-btn" *ngIf="isMessageBtnShown()">-->
<!--                            <mat-icon>chat</mat-icon>-->
<!--                            <span>Message</span>-->
<!--                        </a>-->
<!--                    </ng-container>-->

<!--                </div>-->

            </div>
        </div>
    </div>
    <div class="router-block">
        <ul class="router-list">
<!--            <li class="router-list-item"-->
<!--                [routerLinkActiveOptions]="{exact:true}"-->
<!--                #rla="routerLinkActive"-->
<!--                [routerLinkActive]="'active'">-->
<!--                <a [routerLink]="['watchlist']">Watchlist</a>-->
<!--            </li>-->

            <li class="router-list-item"
                [routerLinkActiveOptions]="{exact:false}"
                #rla="routerLinkActive"
                [routerLinkActive]="'active'">
                <a [routerLink]="['channel-videos',profileUser?.channels[0].id ? profileUser?.channels[0].id : '']">Videos</a>
            </li>

            <li class="router-list-item"
                [routerLinkActiveOptions]="{exact:true}"
                #rla="routerLinkActive"
                [routerLinkActive]="'active'"
            >
                <a [routerLink]="['channel-playlist',profileUser?.channels[0].id ? profileUser?.channels[0].id : '']">Playlist</a>
            </li>

            <li class="router-list-item"
                [routerLinkActiveOptions]="{exact:true}"
                #rla="routerLinkActive"
                [routerLinkActive]="'active'">
                <a [routerLink]="['channel-subscriptions',profileUser?.channels[0].id ? profileUser?.channels[0].id : '']">Contacts</a>
            </li>

            <li class="router-list-item"
                [routerLinkActiveOptions]="{exact:true}"
                #rla="routerLinkActive"
                [routerLinkActive]="'active'">
                <a [routerLink]="['channel-about',profileUser?.channels[0].id ? profileUser?.channels[0].id : '']">About Us</a>
            </li>
        </ul>
    </div>

    <div>
        <router-outlet></router-outlet>
    </div>
</div>
